export default __webpack_public_path__ + "static/media/128.8b474092.png";